module.exports = __webpack_public_path__ + "static/media/leveling-white.53840ad6.svg";